module.exports = __webpack_public_path__ + "images/logo-env_local.svg?f26a65b7e3e7b6df03a200b20d9037ed";